import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Tooltip from '../Tooltip';

import { eapiClient } from '../../../restClient';

import './styles.css';

export default class SingleLineSelect extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showOptions: false,
      selectedOptionValue: undefined,
      selectedOptionDisplayValue: this.props.defaultValue,
      selectedOption: undefined,
      showTooltip: false
    };
  }

  handleWindowClick = () => {
    if (this.state.showOptions === true) {
      this.setState({ showOptions: false });
    }
  }

  handleEditClick = (event) => {
    if (this.props.isreadonly) {
      return;
    }
    else {
      event.stopPropagation();
      if (this.props.onEdit && typeof (this.props.onEdit) === "function") {
        this.props.onEdit(this.state.selectedOption, this.props.editFormLink, this.props.selectType);
      }
    }
  }
  handleEditClickOnEnter = (event) => {
    if (event.keyCode === 13) {
      event.stopPropagation();
      if (this.props.onEdit && typeof (this.props.onEdit) === "function") {
        this.props.onEdit(this.state.selectedOption, this.props.editFormLink, this.props.selectType);
      }
    }
  }

  componentWillMount() {
    if (this.props.resourceURL) {
      this.setState({ optionsData: [] });
      eapiClient(this.props.resourceURL)
        .then(({ data }) => {
          if (this.props.countryTaxonomyUrl !== undefined) {
            let _currentAddress = data.responseData;
            eapiClient(this.props.countryTaxonomyUrl)
              .then(({ data }) => {
                if (data.responseData !== undefined) {
                  let currentListCountries = data.responseData.classificationNodes;
                  _currentAddress = _currentAddress.map(item => {
                    currentListCountries.filter(country => {
                      if (country.id === item.country.value) {
                        item.country.name = country.name
                      }
                    })
                    return item;
                  })
                }
              })
            this.setState({ optionsData: _currentAddress });
          } else {
            this.setState({ optionsData: data.responseData });
          }

          if (data.responseData.length === 0) {
            this.props._onOptionsDataExists(false, this.props.selectType);
          } else {
            this.props._onOptionsDataExists(true, this.props.selectType);
          }
        });
    }
  }

  componentDidMount() {
    window.addEventListener('click', this.handleWindowClick);
    if (this.props._value !== undefined) {
      const selectedOptionValue = this.props._value;
      let selectedOption, selectedOptionDisplayValue;
      (this.state.optionsData || this.props.optionsData).forEach(optionData => {
        if (optionData.id === this.props._value) {
          selectedOption = optionData;
          selectedOptionDisplayValue = this.getOptionText(optionData);
          this.setState({
            selectedOption,
            selectedOptionValue,
            selectedOptionDisplayValue
          });
        }
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps._value === undefined || nextProps._value === null || nextProps._value === '') {
      this.setState({
        selectedOptionValue: undefined,
        selectedOptionDisplayValue: this.props.defaultValue,
        selectedOption: undefined
      });
    } else {
      const selectedOptionValue = nextProps._value;
      let selectedOption, selectedOptionDisplayValue;
      (this.state.optionsData || nextProps.optionsData).forEach(optionData => {
        if (optionData.id === nextProps._value) {
          selectedOption = optionData;
          selectedOptionDisplayValue = this.getOptionText(optionData);
          this.setState({
            selectedOption,
            selectedOptionValue,
            selectedOptionDisplayValue
          });
        }
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.handleWindowClick);
  }

  toggleOptionslist = (event) => {
    if (this.props.isreadonly) {
      return;
    }
    else {
      event.stopPropagation();
      this.setState(prevState => {
        return { showOptions: !prevState.showOptions }
      });
    }
  }
  toggleOptionslistOnEnter = (event) => {
    if (this.props.isreadonly) {
      return;
    }
    if (event.keyCode === 13) {
      event.stopPropagation();
      this.setState(prevState => {
        return { showOptions: !prevState.showOptions }
      });
    }
  }

  onOptionSelected = (selectedOption, event) => {
    event.stopPropagation();
    this.setState({
      showOptions: false,
      selectedOption,
      selectedOptionValue: event.target.getAttribute("value"),
      selectedOptionDisplayValue: event.target.textContent
    });
    if (this.props._onChange && typeof (this.props._onChange) === "function") {
      this.props._onChange({ ...selectedOption }, this.props.selectType);
    }
  }

  getFilteredOptionData = (optionData) => {
    return this.props.requiredFields
      .reduce((acc, requiredField) => {
        if (optionData[requiredField] !== undefined && optionData[requiredField] !== "") {
          // check for object 1 level down
          if (typeof (optionData[requiredField]) === "object" && optionData[requiredField].name) {
            acc.push(optionData[requiredField].name);
          } else {
            acc.push(optionData[requiredField]);
          }
        }
        return acc;
      }, []);
  }

  computeOptionText = (optionData) => {
    const filteredOptionData = this.getFilteredOptionData(optionData);
    return filteredOptionData.length > 0 ? filteredOptionData.join(", ") : '';
  }

  getOptionText = (optionData) => {
    var optionText;
    if (this.props.computeOptionText) {
      optionText = this.props.computeOptionText(this.getFilteredOptionData(optionData));
    } else {
      optionText = this.computeOptionText(optionData);
    }
    return optionText || '';
  }
  toggleTooltip = () => {
    var selector = `[data-tooltip=${this.props.tooltipId}]`
    document.querySelectorAll(selector)[0].setAttribute("aria-expanded", !this.state.showTooltip)
    this.setState({
      showTooltip: !this.state.showTooltip
    })
  }

  toggleTooltiponEnter = (event) => {
    if (event.keyCode === 27) {
      var selector = `[data-tooltip=${this.props.tooltipId}]`
      document.querySelectorAll(selector)[0].setAttribute("aria-expanded", false)
      this.setState({
        showTooltip: !this.state.showTooltip
      })
    }
  }


  render() {
    const chevronIcon = classnames({
      "icon icon-chevron-up": this.state.showOptions === true,
      "icon icon-chevron-down": this.state.showOptions === false
    });
    const editIcon = classnames({
      "gdocs-select-box__edit-area": this.state.selectedOption !== undefined,
      "gdocs-select-box__edit-area hide-icon": this.state.selectedOption === undefined
    });
    const noIcon = classnames({
      "icon-removed": this.state.selectedOption === undefined
    });

    let optionsJsx = (this.state.optionsData || this.props.optionsData).map(optionData => {
      const optionText = this.getOptionText(optionData);
      const optionDisabled = this.props.disabledOptions.indexOf(optionData.id) !== -1;
      const optionCss = classnames('gdocs-single-line-select-container__list_item', {
        'gdocs-single-line-select-container__list_item_disabled': optionDisabled
      });
      return (<li
        tabIndex="0"
        className={optionCss}
        key={optionData.id}
        value={optionData.id}
        onClick={!optionDisabled ? this.onOptionSelected.bind(this, optionData) : (e) => { e.stopPropagation() }}
        onKeyUp={(event) => !optionDisabled && event.keyCode === 13 ? this.onOptionSelected.bind(this, optionData) : (e) => { e.stopPropagation() }}
      >
        {optionText}
      </li>)
    });

    let listJsx = (<ul className="gdocs-single-line-select-container__list">{optionsJsx}</ul>);
    return (
      <div className="gdocs-single-line-select-container">
        <div className="gdocs-select-box">
          <div
            className={`gdocs-select-box__display-area ${noIcon}`}
            tabIndex="0"
            id={this.props.id}
            onKeyUp={this.toggleOptionslistOnEnter}
            onClick={this.toggleOptionslist}
          >
            {this.state.selectedOptionDisplayValue}
          </div>
          <div className={editIcon} onKeyUp={this.handleEditClickOnEnter} onClick={this.handleEditClick} aria-label="Edit" role="button" tabIndex="0">
            <i className="icon icon-edit" aria-label='edit' role='img'></i>
          </div>
          <div className="gdocs-select-box__button-area" onKeyUp={this.toggleOptionslistOnEnter} onClick={this.toggleOptionslist}>
            <i className={chevronIcon} aria-hidden='true'></i>
          </div>
          <div className="clear-area-float yo"></div>
          {
            (this.props.tooltipText !== undefined && this.props.tooltipText !== "")
              ? <button
                className="icon icon-circle-help gdocs-valign-middle gdocs-mleft-5 hintText-icon tooltip-simple-dropdown-hint"
                data-tooltip={this.props.tooltipId}
                onMouseEnter={this.toggleTooltip}
                onMouseLeave={this.toggleTooltip}
                onClick={this.toggleTooltip}
                onKeyUp={(event) => this.toggleTooltiponEnter(event)}
                aria-label={`Additional Information on ${this.props.tooltipId}`}
                aria-expanded="false"
              >
              </button>
              : ''
          }
          <Tooltip
            active={this.state.showTooltip}
            position="right"
            arrow="center"
            parent={this.props.tooltipId}
          >
            <div className="tooltip-content-hintText">
              {this.props.tooltipText}
            </div>
          </Tooltip>
        </div>
        {
          this.state.showOptions
            ? listJsx
            : ""
        }
      </div>
    )
  }
}

SingleLineSelect.defaultProps = {
  requiredFields: [],
  defaultValue: 'Please Select',
  disabledOptions: []
}


SingleLineSelect.propTypes = {
  optionsData: PropTypes.arrayOf(PropTypes.object),
  defaultValue: PropTypes.string,
  _onChange: PropTypes.func,
  onEdit: PropTypes.func,
  requiredFields: PropTypes.arrayOf(PropTypes.string),
  computeOptionText: PropTypes.func,
  disabledOptions: PropTypes.arrayOf(PropTypes.string)
}


// WEBPACK FOOTER //
// ./src/components/common/SingleLineSelect/index.js